import { Box, Container, Grid } from "@mui/material";
import { Fragment } from "react";
import { useFormik } from "formik";
import { useSearchParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import InputTextfield from "../../../../shared/components/textField";
import useMutation from "../../../../shared/components/hooks/useMutation";
import { getValidationSchema } from "../../../../shared/validations/schema";
import { useNavigate } from "react-router-dom";
import CreatePasswordBg from "../../../../assets/img/create-password.svg";
import LoginPageCard from "../../../../shared/components/auth/loginPageCard";
import MenuContainer from "../../../../shared/components/auth/menuContainer";
import LoginRightPanelComponent from "../../../../shared/components/auth/loginRightPanel";
 
const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");
  const { loading, modifyData } = useMutation(`/reset-password`);

  const textFields = [
    {
      id: "newPassword",
      name: "newPassword",
      label: "New Password",
      placeholder: "Enter your new password",
      type: "password",
    },
    {
      id: "confirmPassword",
      name: "confirmPassword",
      label: "Confirm Password",
      placeholder: "Confirm your new password",
      type: "password",
    },
  ];

  const resetPasswordForm = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validateOnBlur: true,
    validationSchema: getValidationSchema(["newPassword", "confirmPassword"]),
    onSubmit: async (formData: any) => {
      // Use the token directly from URL params (useParams)
      if (!token) {
        console.error("Token not found.");
      }

      const response = await modifyData(`/user/change-password`, "post", {
        token: token, // Pass the token as part of the request
        newPassword: formData.newPassword,
      });

      if (response) {
        console.log("Password reset successful!");
        // Navigate to the login page
        navigate("/reset-success"); // Replace "/login" with your login route
      }
    },
  });

  return (
    <>
      <Box sx={{ height: "100%", width: "100%" }}>
        <Container>
          <Grid
            container
            sx={{
              justifyContent: "center",
              alignItems: "end",
              padding: "24px",
              marginTop: "4%",
            }}
          >
            <Grid item md={4}>
              <LoginPageCard padding=" 8% 8% 15% 10%">
                <MenuContainer />
                <form
                  onSubmit={resetPasswordForm.handleSubmit}
                  autoComplete="off"
                  className="resetPasswordForm"
                >
                  {textFields.map((field: any, index: number) => (
                    <Fragment key={field.id}>
                      {(field?.formField === undefined ||
                        field.formField === true) && (
                        <Grid item md={12} sm={12} xs={24}>
                          <InputTextfield
                            form={resetPasswordForm}
                            fieldProps={field}
                            key={index}
                          />
                        </Grid>
                      )}
                    </Fragment>
                  ))}
                  <Grid item md={12} sx={{ mt: 2 }}>
                    <LoadingButton
                      loading={loading}
                      variant="contained"
                      type="submit"
                      fullWidth
                      size="small"
                    >
                      Submit
                    </LoadingButton>
                  </Grid>
                </form>
              </LoginPageCard>
            </Grid>
            <Grid item md={4.5}>
              <LoginRightPanelComponent
                imageSrc={CreatePasswordBg}
                text=""
                title="Create Password"
                subtitle=""
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ResetPassword;
